// Form Error Enums ------------------------------------------------------------------------------------------------------------------------

export enum FormErrorFields {
  ButtonCaption = 'buttonCaption',
  ButtonRoute = 'buttonRoute',
  Code = 'code',
  IsActive = 'isActive',
  Message = 'message',
  ShowClose = 'showClose',
}

// Form Error Interfaces -------------------------------------------------------------------------------------------------------------------

export interface FormErrorRedux {
  [FormErrorFields.ButtonCaption]?: string;
  [FormErrorFields.ButtonRoute]?: string;
  [FormErrorFields.Code]?: string;
  [FormErrorFields.IsActive]: boolean;
  [FormErrorFields.Message]?: string;
  [FormErrorFields.ShowClose]?: boolean;
}
